import { CheckboxFilterGroup } from '@retail/components';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { AssortmentTag } from '@retail/my-assortment/types';
import { useMemo } from 'react';

interface Props {
  assortmentTags: AssortmentTag[];
  selectedAssortmentTags: string[];
  selectAssortmentTags: (assortmentTagId: string) => void;
}

export function SelectAssortmentTags({
  assortmentTags,
  selectedAssortmentTags,
  selectAssortmentTags,
}: Props) {
  const t = useMyAssortmentTFunction();

  const options = useMemo(
    () => assortmentTags.map(({ id, name }) => ({ label: name, value: id.toString() })),
    [assortmentTags]
  );

  return (
    <CheckboxFilterGroup
      collapsible
      label={t('myAssortment.columns.subAssortments')}
      options={options}
      selected={selectedAssortmentTags}
      onToggle={selectAssortmentTags}
      indent={2}
    />
  );
}
